import React, { useCallback, useState } from 'react';
import { HeadSection } from './sections/head-section';
import { Preferences } from './sections/preferences';
import { Opportunities } from './sections/opportunities';
import { Everyone } from './sections/everyone';
import { ConnectRequest } from './sections/connect-request';
import { Questions } from './sections/questions';
import { useIntersectionObserver } from '~/src/helpers/hooks/useIntersectionObserver';
import * as ST from './sections/styled';

export const DomruInternet = () => {
    const [startCounter, setStartCounter] = useState(false);

    const observeHandler = useCallback((entries) => {
        if (entries[0].isIntersecting) {
            setStartCounter(true);
        }
    }, []);

    const everyOneRef = useIntersectionObserver(observeHandler, { root: null, threshold: 0.3 });

    return (
        <ST.DomruInternet>
            <HeadSection />
            <Preferences />
            <Opportunities />
            <Everyone forwardRef={everyOneRef} isStart={startCounter}/>
            <ConnectRequest />
            <Questions />
        </ST.DomruInternet>
    );
};
